<template>
  <div ref="scrollContainer" class="-process-tab-items">
    <ul ref="scrollContent" class="-process-tab-item__wrapper" :style="translateXStyle">
      <li
        v-for="(item, idx) in tabItems"
        :key="idx"
        :class="{'-process-tab-items__active':currentTabIndex === idx}"
        class="-process-tab-item"
        :title="item.title"
        @click="changeIdx(idx)"
      >
        <strong class="-process-tab-item__title">{{ item.title }}</strong>
        <span v-show="showCount" class="-process-tab-item__count">{{ item.count }}</span>
        <span
          v-show="idx < (tabItems.length - 1) && showProcess"
          class="-process-tab-item__image"
        />
      </li>
    </ul>
    <sui-tab-navigator ref="navigator"
      v-model="translateX"
      :containerWidth="containerWidth"
      :contentWidth="contentWidth"
      :contentElement="contentElement"
      :controllerWidth="controllerWidth"
      :refresh="refresh"
    >
    </sui-tab-navigator>
  </div>
</template>

<script>

const NAVIGATOR_WIDTH = 72;

export default {
  name: 'SuiProcessTabItems',
  props: {
    tabContainer: {
      type: null, // It means that any type for that Component Type.
      required: true,
    },

    // 최초 선택된 탭 인덱스 번호 (default: -1 미선택)
    // 첫번 째 보이는 탭 인덱스
    defaultTabIndex: {
      type: Number,
      default: -1,
    },

    // 탭 아이템
    // title: 탭 제목, count: 카운트, checked: 탭 체크 상태 , component: 탭 컨텐츠 컴포넌트
    tabItems: {
      type: Array,
      required: true,
    },

    showProcess: {
      type: Boolean,
      default: true,
    },

    showCount: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentTabIndex: -1,
      translateX: 0,
      containerWidth: 1,
      contentWidth: 1,
      contentElement: null,
      controllerWidth: 72,
    };
  },
  computed: {
    translateXStyle() {
      return `transform: translateX(${this.translateX}px)`;
    },
  },
  watch: {
    defaultTabIndex() {
      this.changeIdx(this.defaultTabIndex);
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.defaultTabIndex >= 0) {
        this.$refs.navigator.init();
        // this._calculateSizeInfo();
        this.changeIdx(this.defaultTabIndex);
        if (this.tabContainer) {
          this.tabContainer.setSelectFunction(this.changeIdx);
        }
      }
    });
    this.refresh();
    this.$root.$on('frame-resize', this.refresh);
    this.contentElement = this.$refs.scrollContent;
  },
  methods: {
    changeIdx(idx) {
      if (this.currentTabIndex !== idx && idx < this.tabItems.length) {
        this.currentTabIndex = idx;
        if (idx >= 0) {
          this.tabContainer.loadTabComponent(this.currentTabIndex);
          this.$emit('change-processtab-idx', idx);
          this.refresh(true);
          this.$refs.navigator.reveal(idx, this.containerWidth);
        }
      }
    },
    getSelectedIndex() {
      return this.currentTabIndex;
    },
    refresh(force = false) {
      if (force) {
        this.containerWidth = parseInt(this.$refs.scrollContainer.getBoundingClientRect().width, 10);
        this.contentWidth = parseInt(this.$refs.scrollContent.getBoundingClientRect().width, 10);
      } else {
        this.$nextTick(() =>{
          this.containerWidth = parseInt(this.$refs.scrollContainer.getBoundingClientRect().width, 10);
          this.contentWidth = parseInt(this.$refs.scrollContent.getBoundingClientRect().width, 10);
        });
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('frame-resize', this.refresh);
  },
};
</script>

<style scoped>
</style>
